<template class="only-agenda">
    <div v-if="lang">
        <div v-show="btndetail === 1" class="sidebar-detail-wrap">
            <ul class="sidebar-detail">
                <li class="detail-header">
                    <h4>{{ detail.day }}</h4>
                    <span>{{ detail.fecha }}</span> 
                </li>
                <ul class="detail-list">
                    <li class="mt-list-cita" v-for="cita in detail.citas" :style="getColor(cita.office_id,2)">
                        <span v-if="cita.data.is_confirmed >= 1"  :class="'status-diary ' + (cita.data.is_confirmed == 3 ? 'success' : 'error')"> {{ cita.data.is_confirmed == 3 ? "Confirmada" : "Cancelada" }}  <md-icon class="icon-status">{{ cita.data.is_confirmed == 3 ? "check" : "close" }}</md-icon> </span>
 <div class="cita-name">{{ verifyIfNull(cita.data.patient.name) + ' ' + verifyIfNull(cita.data.patient.lastname) }}</div>
                        <div class="cita-hour">{{ cita.hour }}
                            <input type="checkbox" class="pull-right" v-model="detail.selected" v-bind:value="cita.id">
                        </div>
                        <div class="cita-comment">{{ cita.data.comment }}</div>
                    </li>
                </ul>
            </ul>
        </div>
        <div :class="[btndetail === 0 ? 'col-sm-12'  : 'col-sm-12 padder-detail', 'hola']">
        <!-- <div class="col-sm-12" style="padding: 15px; /*width: calc(100vw);*/"> -->
                <br/>
                <div class="" style="padding: 15px; margin-bottom: 30px">
                    <div class="mt-calendar-filtros">
                        <button class="mt-calendar-button pull-left" @click="calendarPrev">
                            <md-icon>keyboard_arrow_left</md-icon>
                            <md-tooltip md-direction="top">{{translate.pages.diary.index.actions.prev}}</md-tooltip>
                        </button>
                        <button class="mt-calendar-button pull-left" @click="calendarNext">
                            <md-icon>keyboard_arrow_right</md-icon>
                            <md-tooltip md-direction="top">{{translate.pages.diary.index.actions.prox}}</md-tooltip>
                        </button>
                        <div class="mt-calendar-picker pull-left">
                            <md-icon class="pull-left">date_range</md-icon>
                            <date-picker :option="option" class="picker" :date="startDate" v-model="calendar.iniWeek" @selected="renderCalendar"></date-picker>
                            <div class="clearfix"></div>
                        </div>
                        <div class="pull-left hidden-xs">
                            <md-button-toggle style="position: relative; top: -4px;">
                              <md-button class="md-icon-button" @click.native="changeDetail">
                                <md-icon>chrome_reader_mode</md-icon>
                                <md-tooltip md-direction="top">{{translate.pages.diary.index.actions.detail}}</md-tooltip>
                              </md-button>

                              <md-button class="md-icon-button" @click.native="toPDF">
                                <md-icon>picture_as_pdf</md-icon>
                                <md-tooltip md-direction="top">{{translate.pages.diary.index.actions.pdf}}</md-tooltip>
                              </md-button>

                              <md-button class="md-icon-button" @click.native="toExcel">
                                <md-icon>description</md-icon>
                                <md-tooltip md-direction="top">{{translate.pages.diary.index.actions.excel}}</md-tooltip>
                              </md-button>
                            </md-button-toggle>
                        </div>
                        <div class="col-sm-4 pull-right add-cita">
                            <md-button v-if="detail.selected.length == 0" class="md-icon-button md-raised md-primary pull-right" style="z-index: 20" @click.native="add">
                              <md-icon>add</md-icon>
                            </md-button>
                            <md-button v-else class="md-icon-button md-raised md-danger pull-right" style="z-index: 20"  @click.native="deleteAgenda">
                              <md-icon>clear</md-icon>
                            </md-button>
                            <div class="pull-right" style="width: calc(100% - 122px); margin-right: 10px;">
                                <md-input-container class="mt-filtro-fecha" style="padding: 0 !important; position:relative; top: 6px;">
                                    <md-select name="consultorio" id="consultorio" v-model="calendar.consultorio" @change="consultaChange">
                                        <md-option value="0">{{translate.pages.diary.index.actions.consultas}}</md-option>
                                        <md-option v-for="office in data.listconsultorio" :value="office.id" :key="office.id">
                                            {{office.name}}
                                        </md-option>
                                    </md-select>
                                </md-input-container>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <br/>
                    <div style="display: none;">
                        <table id="toExcel" summary="Citas" rules="groups" frame="hsides" border="2">
                            <caption>Citas</caption>
                            <colgroup align="center"></colgroup>
                            <colgroup align="left"></colgroup>
                            <colgroup span="2" align="center"></colgroup>
                            <colgroup span="3" align="center"></colgroup>
                            <thead valign="top">
                                <tr>
                                    <th>{{translate.pages.diary.index.table_headers.date}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.hour}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.center}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.patient}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.rut}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.sex}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.phone}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.email}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.birthdate}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.age}}</th>
                                    <th>{{translate.pages.diary.index.table_headers.notes}}</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>

                        </div>
                    <div class="mt-border" id="toPDF">
                        <div class="mt-table-responsive">
                            <table v-if="btndetail === 0" id="tableToPDF" class="mt-table mt-calendar">
                                <thead>
                                    <tr>
                                        <td><strong style="color: #56687b;text-transform: uppercase;">Hora</strong></td>
                                        <td v-for="header in calendar.headers" v-html="header.label" :class="{ 'mt-header-active': header.active }">
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="hour in this.calendar.hours">
                                        <td>{{ hour.label }}</td>
                                        <td v-for="(citas, index) in getCitas(hour)"  :class="{ 'agenda-active-td': index == dayindex }">
                                            <div v-for="cita in citas" class="mt-cita" :style="getColor(cita.office_id)" @click="showModal(cita)">
                                                <!-- <div>{{ cita.title }}</div> -->
                                                <span v-if="cita.data.is_confirmed >= 1"  :class="'status-diary ' + (cita.data.is_confirmed == 3 ? 'success' : 'error')"> {{ cita.data.is_confirmed == 3 ? "Confirmada" : "Cancelada" }}  <md-icon class="icon-status">{{ cita.data.is_confirmed == 3 ? "check" : "close" }}</md-icon> </span>
                                                <div>{{ verifyIfNull(cita.data.patient.name) + ' ' + verifyIfNull(cita.data.patient.lastname) }}</div>
                                                <div>{{ cita.hour }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table v-else class="mt-table mt-calendar mt-calendar2">
                                <thead>
                                    <tr>
                                        <td v-for="header in calendar.headers" v-html="header.label" :class="{ 'mt-header-active': header.active }">
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="hour in this.calendar.hours">
                                        <td v-for="(citas, index) in getCitas(hour)" :class="{ 'agenda-active-td': index == dayindex }">
                                            <div v-for="cita in citas" class="mt-cita-detail text-center tooltip" :style="getColor(cita.office_id)" @click="showModal(cita)">
                                                <div>{{ cita.hour }}</div>
                                                <!-- <span class="tooltiptext">{{ cita.title }}</span> -->
                                                <span class="tooltiptext">{{ verifyIfNull(cita.data.patient.name) + ' ' + verifyIfNull(cita.data.patient.lastname) }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <ul v-if="events.length > 0" class="mt-leyenda hidden">
                            <li v-for="event in events" > <div class="mt-circle" :style="getColor(event.office_id)"></div> <div class="pull-left" style="margin-right: 15px;">{{ event.data.office.name }}</div></li>
                            <div class="clearfix"></div>
                        </ul>
                    </div>
                </div>
                <div id="myModal" class="mt-modal add-cita-modal">
                    <div class="mt-modal-content" style="max-width: 700px">
                        <div class="col-sm-12">
                            <header class="content-header">
                                <h3 class="dialog--title">{{translate.pages.diary.index.add_cita_modal.title}}</h3>
                                <hr>
                            </header>
                        </div>
                        <div class="col-sm-6">
                            <md-input-container>
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.office}}</label>
                                <md-select disabled class="forcedisabled" name="cita" id="cita" v-model="cita.office_id" >
                                    <md-option v-for="office in data.listconsultorio" :value="office.id" :key="office.id">
                                        {{office.name}}
                                    </md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.office">{{ errors.office }}</span>
                            </md-input-container>
                        </div>
                        <div class="col-sm-6">
                            <md-input-container :class="{ 'md-input-invalid' : errorsPatient.hasOwnProperty('code') }">
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.code}}</label>
                                <md-input disabled class="forcedisabled" v-model="patient.code" @change="changeCodePatient()"></md-input>
                                <span :class="['md-error', { 'code_active': data.activeCode === 1 }]" v-if="errorsPatient.code">{{ errorsPatient.code }}</span>
                            </md-input-container>
                        </div>
                        <div class="clearfix"></div>
                        <br/>
                        <div class="well" style="margin-left: 15px; margin-right: 15px; margin-top: -10px; margin-bottom: 8px;">
                            <div class="col-sm-6">
                                <md-input-container>
                                    <label>{{translate.pages.diary.index.add_cita_modal.fields.name}}</label>
                                    <md-input v-model="patient.fullname" disabled class="patient-modal-input"></md-input>
                                </md-input-container>
                            </div>
                            <div class="col-sm-6">
                                <md-input-container>
                                    <label>{{translate.pages.diary.index.add_cita_modal.fields.birthdate}}</label>
                                    <md-input v-model="patient.birth_date" disabled></md-input>
                                </md-input-container>
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-sm-6">
                                <md-input-container>
                                    <label>{{translate.pages.diary.index.add_cita_modal.fields.email}}</label>
                                    <md-input v-model="patient.email" disabled class="patient-modal-input" ></md-input>
                                </md-input-container>
                            </div>
                            <div class="col-sm-6">
                                <md-input-container>
                                    <label>{{translate.pages.diary.index.add_cita_modal.fields.phone}}</label>
                                    <md-input v-model="patient.phone" disabled class="patient-modal-input"></md-input>
                                </md-input-container>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-sm-6">
                            <!-- <div class="picker-rare datepicker--block" :class="[ 'mt-input-container', { 'md-input-invalid' : errors.hasOwnProperty('fecha') }]">
                                <label>Fecha</label>
                                <md-icon>date_range</md-icon>
                                <date-picker :option="option" class="pull-left picker" :date="currentDate" v-model="cita.fecha"></date-picker>
                                <span class="md-error" v-if="errors.fecha">{{ errors.fecha }}</span>
                            </div> -->
                             <div class="amolpicker container-date picker-rare" :class="[ '', { 'md-input-invalid' : errors.hasOwnProperty('fecha') }]">
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.start_date}}</label>
                                <md-icon class="icon-calendar">today</md-icon>
                                <date-picker :option="option" class="picker" :date="currentDate" v-model="cita.fecha"></date-picker>
                                <small class="small-error" v-if="errors.fecha">{{ errors.fecha }}</small>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <md-input-container class="datepicker--block" :class="{ 'md-input-invalid' : errors.hasOwnProperty('hora') }">
                                <md-icon style="margin-right: 10px;">access_time</md-icon>
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.hour}}</label>
                                <md-select name="hora" id="patient_hora" v-model="cita.hora" :disabled="cita.disabled">
                                    <md-option v-for="(hour,index) in cita.hours" :key="index" :value="hour">{{ hour }}</md-option>
                                </md-select>
                            </md-input-container>
                            <span class="md-error" v-if="errors.hora">{{ errors.hora }}</span>
                        </div>
                        <div class="clearfix"></div>
                        <div class="col-sm-6">
                            <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('status') }">
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.status.title}}</label>
                                <md-select name="patient_status" id="patient_status" v-model="cita.status">
                                    <md-option value="1">{{translate.pages.diary.index.add_cita_modal.fields.status.values.wait}}</md-option>
                                    <md-option value="2">{{translate.pages.diary.index.add_cita_modal.fields.status.values.ocupped}}</md-option>
                                    <md-option value="3">{{translate.pages.diary.index.add_cita_modal.fields.status.values.away}}</md-option>
                                    <md-option value="4">{{translate.pages.diary.index.add_cita_modal.fields.status.values.canceled}}</md-option>
                                    <md-option value="5">{{translate.pages.diary.index.add_cita_modal.fields.status.values.reprogramming}}</md-option>
                                    <md-option value="6">{{translate.pages.diary.index.add_cita_modal.fields.status.values.completed}}</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.status">{{ errors.status }}</span>
                            </md-input-container>
                        </div>
                        <div class="col-sm-6">
                            <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('comment') }">
                                <label>{{translate.pages.diary.index.add_cita_modal.fields.comments}}</label>
                                <md-input v-model="cita.comment"></md-input>
                                <span class="md-error" v-if="errors.comment">{{ errors.comment }}</span>
                            </md-input-container>
                        </div>
                        <div class="col-sm-12">
                            <footer class="content-footer">
                                <hr>
                                <div class="buttons clearfix">
                                    <md-button class="md-raised mt-btn-second pull-left md-size sm-size" v-on:click.native="closeModal">{{translate.pages.diary.index.add_cita_modal.cancel_btn}}</md-button>
                                    <md-button class="md-raised mt-btn-primary pull-right md-size sm-size" v-on:click.native="saveCita" :disabled="process">{{translate.pages.diary.index.add_cita_modal.edit_btn}}</md-button>
                                </div>
                            </footer>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login, doctor } from '../../../config/api.js';
    window.jQuery = window.$ = require('jquery');
    window.jsPDF = require('jspdf/dist/jspdf.debug.js');
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    import moment from 'moment';
    import _ from 'lodash';
    const swal = require('sweetalert2');

    // Add days to prototype Date
    Date.prototype.addDays = function(days) {
        var _date = new Date(this.valueOf());
        _date.setDate(_date.getDate() + days);
        return _date;
    }
    // Clone to prototype Date
    Date.prototype.clone = function () {
        return new Date(this.getTime());
    }
    // Format toYMD prototype Date
    Date.prototype.toYMD = function () {
        var _date = new Date(this.valueOf());
        var d = _date.getDate();
        var m = _date.getMonth() + 1;
        var y = _date.getFullYear();
        return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    }
    // Format getAge prototype Date
    Date.prototype.getAge = function() {
        var birthday = new Date(this.valueOf());
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getFullYear() - 1970);
    }

    // Get the modal
    var modal = document.getElementById('myModal');

    window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }

    export default {
        components: { 'date-picker': myDatepicker },
        props: [ 'sidevisible' ],
        data() {
            return {
                process: false,
                startDate: { time: datepicker.now_format, block: false},
                currentDate: { time: '' },
                option: options,
                detail: {
                    selected: [],
                    day: '',
                    date: '',
                    fecha: '',
                },
                btndetail: 0,
                colors: ["#e228a3","#16d331","#54f816","#f292be","#b3c37b","#b16b91","#96a9aa","#c054c4","#d5f3fe","#ce7ce4","#34a2ce","#8844c6","#f3fe2e","#ecfdac","#1322c","#803c0","#c49744","#5224e3","#9ae4bc","#e3bf0c","#69a74","#632cfb","#dd65ae","#cf7760","#5a80da","#20aeb9","#390824","#ee7214","#95b9ad","#de4b90","#c3aa52","#ee11ac","#615902","#f776c0","#cd6012","#252588","#40081","#d79f9b","#7eefd7","#820127","#c9b7f1","#8be970","#1ba251","#e03757","#86d681","#48db15","#4b27fe","#fdb2b0"],
                colorByOffice: {

                },
                format: 'dd / MMMM / yyyy',
                cita: {
                    office_id  : '',
                    patient_id : '',
                    fecha      : '',
                    hora       : '',
                    status     : 1,
                    comment    : '',
                    disabled : true
                },
                calendar: {
                    consultorio : '0',
                    today       : new Date(),
                    iniWeek     : '',
                    format      : 'dd / MM / yyyy',
                    iniTime     : 0,
                    finTime     : 24,
                    options     : {
                        months : ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                        days   : ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                    },
                    headers: [
                    ],
                    hours:[
                    ]
                },
                events      : [],
                defaultView : "agendaWeek",
                config      : {
                      minTime : "07:00",
                      maxTime : "22:00",
                      header  : {
                        left  : "prev,next",
                        right : ""
                      },
                  },
                language : 'es',
                alert    : {
                    msg : '',
                },
                doctor : {
                    code                     : '',
                    name                     : '',
                    lastname                 : '',
                    lastname2                : '',
                    email                    : '',
                    phone                    : '',
                    password                 : '',
                    password_confirmation    : '',
                    speciality               : [],
                    notification_appointment : false,
                    notification_mail        : false,
                    notification_sms         : false,
                    type                     : 'doctor',
                },
                profile_image: 'http://localhost/api-amol/public/avatar/default.jpg',
                patient: {
                    code       : '',
                    fullname   : '',
                    birth_date : '',
                       email      : '',
                },
                data: {
                    listspecialities : [],
                    listconsultorio: [],
                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                    activeCode : 0,
                    // activeTab : 0,
                },
                errorsPatient: {
                    code: '',
                },
                errors: {
                    office  : '',
                    patient : '',
                    fecha   : '',
                    hora    : '',
                    status  : '',
                    comment : '',
                },
                route: {
                    doctor: doctor,
                }
            }
        },
        beforeCreate(){
            self = this;
        },
        beforeMount(){
            this.renderCalendar(new Date());
            // this.getAgenda(new Date());
            let url = this.route.doctor.api.list.office;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get list office by doctor
            this.$http.get(url, {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        self.data.listconsultorio = response.data.data;

                    }
                });
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Update detail
            changeDetail(){
                this.btndetail = this.btndetail == 0 ? 1 : 0;
                if(this.btndetail==1){
                    this.hideSidebar();
                }else{
                    this.showSidebar();
                }
            },
            // hide sidebar
            hideSidebar(){
                if(this.sidevisible == true){
                    this.$emit('toggleSidebar');
                }
            },
            // show sidebar
            showSidebar(){
                if(this.sidevisible == false){
                    this.$emit('toggleSidebar');
                }
            },
            // Format Date
            parseDate(input) {
              var parts = input.split('-');
              // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
              return new Date(parts[0], parts[1]-1, parts[2]); // Note: months are 0-based
            },
            // Export excel
            toExcel(){
                var tableToExcel = (function() {
                    var uri = 'data:application/vnd.ms-excel;base64,',
                        template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                        base64 = function(s) {
                            return window.btoa(unescape(encodeURIComponent(s)))
                        },
                        format = function(s, c) {
                            return s.replace(/{(\w+)}/g, function(m, p) {
                                return c[p];
                            })
                        }
                    return function(table, name) {
                        if (!table.nodeType) table = document.getElementById(table)
                        var ctx = {
                            worksheet: name || 'Worksheet',
                            table: table.innerHTML
                        }
                        // window.location.href = uri + base64(format(template, ctx))

                        var link = document.createElement('a');
                          if (typeof link.download === 'string') {
                            link.href = uri + base64(format(template, ctx));
                            link.download = "Agenda Medica.xls";

                            //Firefox requires the link to be in the body
                            document.body.appendChild(link);

                            //simulate click
                            link.click();

                            //remove the link when done
                            document.body.removeChild(link);
                          } else {
                            window.open(uri);
                          }
                    }
                })();
                $("#toExcel tbody").empty();
                $(self.events).each(function(i,data){
                    var predate = data.start.split(/[^0-9]/);
                    var dateObj=new Date (predate[0],predate[1]-1,predate[2],predate[3],predate[4],predate[5] );

                    var row = '<tr>' +
                                    '<td>' + dateObj.toYMD() +'</td>' +
                                    '<td>' + data.hour +'</td>' +
                                    '<td>' + data.title +'</td>' +
                                    '<td>' + data.data.patient.lastname+ ' ' +data.data.patient.lastname2 +', '+ data.data.patient.name +'</td>' +
                                    '<td>' + data.data.patient.code +'</td>' +
                                    '<td>' + data.data.patient.gender +'</td>' +
                                    '<td>' + data.data.patient.phone +'</td>' +
                                    '<td>' + data.data.patient.email +'</td>' +
                                    '<td>' + data.data.patient.birth_date +'</td>' +
                                    '<td>' + (new Date(data.data.patient.birth_date)).getAge() +'</td>' +
                                    '<td>' + (data.data.comment == null ? '' : data.data.comment) +'</td>' +
                                '</tr>';
                    $("#toExcel tbody").append(row);
                });
                tableToExcel('toExcel', 'Agenda Medica');
            },
            // Get Data
            getData(_table){
                var array = [];
                var headers = [];
                var arrayItem = {};
                $(_table +' thead td').each(function(index, item) {
                    headers[index] = {
                        name   : $(item).children().first().text(),
                        prompt : $(item).children().first().text(),
                        width  : 35,
                        align: 'center'
                    };
                    arrayItem[headers[index].name] = index != 0 ? $(item).children().last().text() : '';
                });
                $(_table +' tbody tr').has('td').each(function() {
                    var arrayItem = {};
                    $('td', $(this)).each(function(index, item) {
                        arrayItem[headers[index].name] = $(item).text();
                    });
                    array.push(arrayItem);
                });
                return { head: headers, body: array};
            },
            // Export PDF
            toPDF(){
                var doc = new jsPDF();
                var ini = self.calendar.iniWeek;
                var fin = self.calendar.iniWeek.addDays(+7);

                doc.text('Agenda Medica', 10, 10);
                doc.text(ini.toYMD() +'  -  '+ fin.toYMD(), 10, 20);
                var data = self.getData(".mt-table");
                doc.table(10, 30, data.body, data.head, {
                    autoSize: false,
                    printHeaders: true
                })
                doc.save('Agenda Medica.pdf')
            },
            // Export
            exportar2(){
                html2canvas(document.body).then(function(canvas) {
                    document.body.appendChild(canvas);
                });
                // html2canvas($('#toPDF').get(0)).then(function(canvas) {
                //     // document.body.appendChild(canvas);
                //     // var img = canvas.toDataURL("image/png");
                //     var doc = new jsPDF();
                //     doc.addImage(canvas, 'JPEG', 20, 20);
                //     doc.save('AgendaMedica.pdf');
                // });
                // html2canvas($('#toPDF').get(0), {
                //     onrendered: function(canvas) {

                //         var img = canvas.toDataURL("image/png");
                //         var doc = new jsPDF();
                //         doc.addImage(img, 'JPEG', 20, 20);
                //         doc.save('AgendaMedica.pdf');
                //     }

                // });
            },
            // Export PDF
            exportar3() {
                var pdf = new jsPDF('p', 'pt', 'letter')
                , source = $('#toPDF').get(0)
                , specialElementHandlers = {
                    // element with id of "bypass" - jQuery style selector
                    '#bypassme': function(element, renderer){
                        // true = "handled elsewhere, bypass text extraction"
                        return true
                    }
                }, margins = {
                    top: 80,
                    bottom: 60,
                    left: 40,
                    width: 900
                };
                pdf.fromHTML(
                    source // HTML string or DOM elem ref.
                    , margins.left // x coord
                    , margins.top // y coord
                    , {
                        'width': margins.width // max width of content on PDF
                        , 'elementHandlers': specialElementHandlers
                    },
                    function (dispose) {
                      // dispose: object with X, Y of the last line add to the PDF
                      //          this allow the insertion of new lines after html
                      pdf.save('AgendaMedica.pdf');
                    },
                    margins
                )
                // pdf.output("dataurlnewwindow");
                // var doc = new jsPDF();
                // var elementHandler = {
                //   '#ignorePDF': function (element, renderer) {
                //     return true;
                //   }
                // };
                // var source = window.document.getElementsByTagName("body")[0];
                // doc.fromHTML(
                //     source,
                //     15,
                //     15,
                //     {
                //       'width': 180,'elementHandlers': elementHandler
                //     });

                // doc.output("dataurlnewwindow");
            },
            // Get Color by office
            getColor(office_id, type){
                type = type || 1
                if(typeof(self.colorByOffice[office_id]) === "undefined"){
                    var index = Object.keys(self.colorByOffice).length
                    self.colorByOffice[office_id] = self.colors[index];
                }
                if(type == 1){
                    return {
                        'background-color': self.colorByOffice[office_id]
                    }
                }else{
                    return {
                        'border-left': '5px solid ' + self.colorByOffice[office_id]
                    }
                }
            },
            // Route add Diary
            add() {
                this.$router.push({'name': 'AgendaAdd'});
            },
            // Store Diary
            saveCita(){
                this.process = true;
                this.cita.fecha = this.currentDate.time;
                let url = this.route.doctor.api.diary.update+this.cita.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.put(url, this.cita, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        this.process = false;
                        if(response.data.status == "OK"){
                            self.closeModal();
                            swal('', response.data.msg, 'success')
                                .then( () => {
                                    self.getAgenda(new Date());
                                }, (dismiss) => {
                                    self.getAgenda(new Date());
                                });
                        }else{
                             swal('', response.data.msg, 'error')
                                .then( () => {
                                    self.getAgenda(new Date());
                                }, (dismiss) => {
                                    self.getAgenda(new Date());
                                });
                        }
                    }).catch(error => {
                        this.process = false;
                        console.log(error);
                        if(error.response){
                            if(error.response.status = 422){
                                this.setErrors(error.response.data);
                            }
                        }
                    });
            },
            // Get Diary by date
            getAgenda(_date){
                // var _date      = new Date();
                var dateOfWeek = _date.getDay() != 0 ? _date.addDays(-_date.getDay()) : _date;
                var ini        = dateOfWeek.addDays(+1);
                var fin        = dateOfWeek.addDays(+7);
                ini.setHours(0,0,0,0);
                fin.setHours(0,0,0,0);
                let url = '/diary/filter';
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, {
                        ini: ini.toYMD(),
                        fin: fin.toYMD(),
                        consulta: self.calendar.consultorio
                    }, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                .then(response => {
                    if(response.data.status == "OK"){
                        self.events = response.data.data;
                        self.setCitaDetail();
                        self.calculateHours();
                    }
                });
            },
            // Open Modal
            showModal(_cita){
                this.currentDate.time = moment(_cita.data.fecha).format('DD/MM/YYYY');
                self.cita.id          = _cita.data.id;
                self.cita.office_id   = _cita.data.office_id;
                self.cita.patient_id  = _cita.data.patient_id;
                self.cita.fecha       = _cita.data.fecha;
                self.cita.hora        = _cita.data.hora;
                self.cita.status      = _cita.data.status+"";
                self.cita.comment     = _cita.data.comment;
                self.patient          = _cita.data.patient;
                self.patient.fullname = _cita.data.patient.name +' '+ _cita.data.patient.lastname +' '+ _cita.data.patient.lastname2;
                //self.changeCodePatient();
                let filter = {'date': this.currentDate.time, 'office_id': self.cita.office_id};
                this.updateHours(filter);
            },
            // Close Modal
            closeModal(){
                var modal = document.getElementById('myModal');
                modal.style.display = "none";
                var _body = document.getElementsByTagName("BODY")[0];
                _body.style.overflow = "auto";
            },
            // Get Diarys
            getCitas(_element){
                //console.log(_element);
                var _result    = [];
                var _date      = this.calendar.iniWeek;
                var dateOfWeek = _date.getDay() != 0 ? _date.addDays(-_date.getDay()) : _date;
                // dateOfWeek     = dateOfWeek.addDays(+1);
                for (var j = 0; j < 7; j++) {
                    var _data    = [];
                    // var fechaIni = _element.days[j-1].day;
                    var fechaIni = _element.days[j].day;
                    var fechaFin = fechaIni.clone();
                    fechaFin.setHours(fechaIni.getHours() + 1);
                    for(var z=0; z<this.events.length; z++){
                        var _day = this.events[z].start;
                        var predate = _day.split(/[^0-9]/);
                        var tempDate=new Date (predate[0],predate[1]-1,predate[2],predate[3],predate[4],predate[5] );
                        if(fechaIni <= tempDate && tempDate < fechaFin){
                            _data.push(this.events[z]);
                        }
                    }
                    _result.push(_data);
                    dateOfWeek = dateOfWeek.addDays(+1).clone();
                }
                return _result;
            },
            // Calculate Hours
            calculateHours(){
                this.calendar.hours = [];
                var _date           = this.calendar.iniWeek;
                // var dateOfWeek      = _date.getDay() != 0 ? _date.addDays(-_date.getDay()) : _date;
                // dateOfWeek          = dateOfWeek.addDays(+1);
                for (var i = this.calendar.iniTime; i < this.calendar.finTime; i++) {
                    var tempHour   = {};
                    tempHour.label = ((i+"").length == 1 ? "0" : "") + (i > 12 ? i-12 : i) + ":00 " + (i/12 >= 1 ? "PM" : "AM");
                    tempHour.hour  = i;
                    tempHour.days  = [];
                    for (var j = 0; j < 7; j++) {
                        if(j == 0){
                            _date          = this.calendar.iniWeek;
                            var dateOfWeek = _date.getDay() != 0 ? _date.addDays(-_date.getDay()) : _date;
                            // dateOfWeek     = dateOfWeek.addDays(+1);
                        }
                        var tempDay = {};
                        dateOfWeek.setHours(tempHour.hour,0,0,0);
                        tempDay.day = dateOfWeek.clone();
                        tempHour.days.push(tempDay);
                        dateOfWeek = dateOfWeek.addDays(+1);
                    }
                    this.calendar.hours.push(tempHour);
                }
            },
            // Calendar Previous
            calendarPrev(_prev){
                this.calendar.iniWeek = this.calendar.iniWeek.addDays(-1);
                this.startDate.time = moment(this.calendar.iniWeek).format('DD/MM/YYYY')
            },
            // Calendar Next
            calendarNext(_next){
                this.calendar.iniWeek = this.calendar.iniWeek.addDays(+1);
                this.startDate.time = moment(this.calendar.iniWeek).format('DD/MM/YYYY')
            },
            // Change diary
            consultaChange(){
                this.renderCalendar(this.calendar.iniWeek);
            },
            // Set detail by date
            setDetail(_date){
                this.detail.date     = _date;
                this.detail.day      = this.calendar.options.days[_date.getDay()];
                this.detail.fecha    = _date.getDate() +' de '+ this.calendar.options.months[_date.getMonth()-1] +', '+ _date.getFullYear();
                this.detail.selected = [];
            },
            // Set Diary detail
            setCitaDetail(){
                var fechaIni = this.calendar.iniWeek;
                fechaIni.setHours(0,0,0,0);
                var fechaFin = fechaIni.clone();
                fechaFin.setHours(23,59,59,59);
                var _tempCitas = [];
                for(var z=0; z<this.events.length; z++){
                    var _temp = {};
                    var _day = this.events[z].start;
                    var predate = _day.split(/[^0-9]/);
                    var tempDate=new Date (predate[0],predate[1]-1,predate[2],predate[3],predate[4],predate[5] );
                    if(fechaIni <= tempDate && tempDate < fechaFin){
                        _tempCitas.push(this.events[z]);
                    }
                }
                this.detail.citas = _tempCitas;
            },
            // Show calendar
            renderCalendar(_date){
                this.calendar.iniWeek = _date;
                this.setDetail(this.calendar.iniWeek);
                var dateOfWeek        = _date.getDay() != 0 ? _date.addDays(-_date.getDay()) : _date;
                // dateOfWeek            = dateOfWeek.addDays(+1);
                this.calendar.headers = [];

                for (var i = 0; i < 7; i++) {
                    var temp = {};
                    temp.label = '<strong style="color: #56687b;text-transform: uppercase;">'+ this.calendar.options.days[i]+ '</strong> <br>' + this.calendar.options.months[dateOfWeek.getMonth()] + " " + dateOfWeek.getDate();
                    temp.active = this.calendar.iniWeek.getTime() === dateOfWeek.getTime() ? true : false;
                    if(temp.active) {
                        this.dayindex = i;
                    }
                    this.calendar.headers.push(temp);
                    dateOfWeek = dateOfWeek.addDays(+1);
                }
                this.getAgenda(_date);
                // this.calculateHours();
            },
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close Modal
            closeDialog(ref) {
                this.$refs[ref].close();
                self.alert.msg = '';
            },
            onOpen() {
                //console.log('Opened');
            },
            onClose(type) {
                //console.log('Closed', type);
            },
            // Back Modal
            backStep(e){
                this.data.activeTab -= 1;
            },
            // Next Modal
            nextStep(e){
                this.data.activeTab += 1;
            },
            // Delete Diary
            deleteAgenda(e){
                //console.log('send');
            },
            'eventClick' (event, jsEvent, pos) {
               //console.log('eventClick', event, jsEvent, pos)
            },
            // Change code patient
            changeCodePatient: _.debounce(
                function () {
                    this.$http.post(this.route.doctor.api.patient.exists, { code: this.patient.code })
                        .then((response) => {
                            // this.errorsPatient.code = 'Paciente encontrado: "' + response.data.patient.name +' '+ response.data.patient.lastname +' '+ response.data.patient.lastname2 +'"';
                            this.errorsPatient.code = '';
                            this.cita.patient_id = response.data.patient.id;
                            this.data.activeCode = 1;
                        }).catch(error => {
                            console.log(error);
                            if(error.response){
                                if(error.response.status = 422){
                                    this.errorsPatient.code = error.response.data.code[0];
                                    this.cita.patient_id = '';
                                    this.data.activeCode = 0;
                                }
                            }
                        });
                },
                500
            ),
            // Remove diary
            deleteAgenda(){
                let url = '/diary/deletes';
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.process = true;
                this.$http.post(url, {
                        citas: self.detail.selected
                    }, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                .then(response => {
                    this.process = false;
                    if(response.data.status == "OK"){
                        self.data.listcitas = response.data.data;
                        swal('', response.data.msg, 'success')
                                    .then( () => {
                                        self.renderCalendar(self.calendar.iniWeek);
                                    }, (dismiss) => {
                                        self.renderCalendar(self.calendar.iniWeek);
                                    });
                    }else{
                            self.data.confirmation.isSuccess = false;
                            self.data.confirmation.isError   = true;
                            self.alert.msg = response.data.msg;
                            swal('', response.data.msg, 'error')
                                    .then( () => {
                                        // this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        // this.$router.push({'name': 'Agenda'});
                                    });
                        }
                });
            },
            // Update hours
            updateHours(filter){
                let self = this;
                // consult
                this.$http.post('/diary/getHours', filter ,{
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    self.cita.hours = response.data;
                    setTimeout(function(){
                        // show modal
                        var modal = document.getElementById('myModal');
                        modal.style.display = "block";
                        var _body = document.getElementsByTagName("BODY")[0];
                        _body.style.overflow = "hidden";
                        self.cita.disabled = false;
                    },500)
                });
            },
            // print empty string if null
            verifyIfNull(value){
                if (value === null) {return ''}
                return value
            }
        },
        watch: {
            'startDate.time': function(){
                this.renderCalendar(new Date(moment(this.startDate.time,'DD/MM/YYYY').format()));
            },
            'currentDate.time': function(date){
                let filter = {'date': date, 'office_id': this.cita.office_id};
                this.updateHours(filter);
            }
        }
    }

</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/boots.styl'
</style>
<style lang="stylus">
    .hidden
        display none!important
    .mt-calendar-filtros .cov-datepicker
        border none!important
    .mt-calendar-picker
        border 1px solid #dcdee0
        -webkit-border-radius 2px
        -moz-border-radius 2px
        border-radius 2px
        margin-right 5px
    .mt-calendar-picker i
        margin-top 8px
        margin-left 5px
    .mt-calendar-picker input
        padding 11px
        width 122px
        letter-spacing 1px
        font-size 14px
        border none
        cursor pointer
    .vdp-datepicker input
        background transparent
        border 0 !important
        color #384d60 !important
        font-family 'Roboto'
        font-size 14px !important
        font-weight 500
    .mt-input-container > .vdp-datepicker > input
        width 100%!important
        border none!important
        cursor pointer!important
        background-color transparent!important
</style>
<style lang="stylus" scoped>
    .cov-datepicker
        border none!important
    .md-select-value
        padding-left: 27px;
    .mt-border
        overflow hidden
        border 1px solid #cbd0d6
        -webkit-border-radius 5px
        -moz-border-radius 5px
        border-radius 5px
    .mt-calendar
        margin-bottom: 0;
        width: calc(100% - 1px);
        max-width: calc(100% - 1px);
        /* width calc(100% - 1px) */
        border-spacing 0
        border-collapse collapse
    .mt-calendar > thead
        background-color #f5f7fa
    .mt-calendar > thead > tr > td
        text-align center
        color #a2a8b4
        font-size 12px
    .mt-calendar > tbody > tr > td:first-child
        text-align center
        color #a2a8b4
    .mt-calendar > tbody > tr
        border 1px solid #e4e9f0
    .mt-calendar>thead>tr>td, .mt-calendar>thead>tr>th
        border-bottom 1px solid #cbd0d6
        padding-top 10px
        padding-bottom 10px
    .mt-calendar>tbody>tr>td, .mt-calendar>tbody>tr>th
        padding 0
        border 1px solid #e4e9f0
    .mt-calendar>tbody>tr>td:first-child, .mt-calendar>tbody>tr>th:first-child
        padding-top 10px
        padding-bottom 10px
    .mt-calendar-button
        width 40px
        height  40px
        background-color #f5f7fa
        color #959ea6
        border 1px solid #dcdee0
        text-align center
        -webkit-border-radius 2px
        -moz-border-radius 2px
        border-radius 2px
        margin-right 5px
        cursor pointer
        transition all 0.3s ease
    .mt-calendar-button:hover
        color #FFF
        background-color #39b7c0
        border-color #279199
    .md-danger
        background-color #f26061!important
        color #ffffff!important
    .mt-filtro-fecha
        padding-top 0!important
        padding-bottom 0!important
        min-height 14px!important
        border 1px solid #dcdee0
        -webkit-border-radius 2px
        -moz-border-radius 2px
        border-radius 2px
    .mt-filtro-fecha:after
        border none!important
        content none!important
    .mt-filtro-fecha>.md-select
        height 38px!important
        padding-left 15px
    .mt-header-active
        background-color #fbe9e9
    .mt-cita
        padding 10px
        /* margin-bottom 2px */
        -webkit-border-radius 2px
        -moz-border-radius 2px
        border-radius 2px
        cursor pointer
        color #ffffff
    /* Modal */
    /* Modal background */
    .mt-modal
        display none; /* Hidden by default */
        position fixed; /* Stay in place */
        z-index 9; /* Sit on top */
        padding-top 36px; /* Location of the box */
        left 0;
        top 0;
        width 100%; /* Full width */
        height 100%; /* Full height */
        overflow auto; /* Enable scroll if needed */
        background-color rgb(0,0,0); /* Fallback color */
        background-color rgba(0,0,0,0.4); /* Black w/ opacity */
    /* Modal Content */
    .mt-modal-content
        height: calc(100vh - 72px);
        overflow-y: auto;
        background-color #fefefe;
        margin auto;
        padding 20px;
        border 1px solid #888;
        width 80%;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
        border 1px solid #cbd0d6
        -webkit-border-radius 5px
        -moz-border-radius 5px
        border-radius 5px

    .mt-close
        color #aaaaaa;
        float right;
        font-size 28px;
        font-weight bold;

    .mt-close:hover,
    .mt-close:focus
        color #000;
        text-decoration none;
        cursor pointer;

    @-webkit-keyframes animatetop
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}

    @keyframes animatetop
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    /* Modal */
    .mt-input-container > label
        pointer-events auto
        top 6px
        opacity 1
        font-size 12px
        color #959ea6 !important
        position absolute
        /* left 0 */
        transition all .4s cubic-bezier(.25,.8,.25,1)
    .mt-input-container:after
        position absolute
        margin-left 15px
        margin-right 15px
        left 0
        height 1px
        right 0
        bottom 0
        background-color #cbd0d6 !important
        content " "
    .well
      min-height 20px
      padding 10px
      margin-bottom 20px
      background-color #f5f5f5
      border 1px solid #e3e3e3
      border-radius 4px
      -webkit-box-shadow inset 0 1px 1px rgba(0, 0, 0, 0.05)
      box-shadow inset 0 1px 1px rgba(0, 0, 0, 0.05)
    .well-lg
      padding 24px
      border-radius 6px
    .well-sm
      padding 9px
      border-radius 3px
    .well-nobackground
        background-color transparent!important
        border none!important
    hr
        border none
        border-bottom 1px solid #edeef2 !important
    /* Buttons */
    .mt-btn-primary
        background-color #fac31d!important
        color #ffffff!important
    .mt-btn-second
        background-color #f0f0f0!important
        color #41bac2!important
    .mt-circle
        padding 4px 4px
        border-radius 100%
        margin-top 6px
        margin-left 5px
        margin-right 5px
        width 2px
        height 2px
        float left
    ul.mt-leyenda
        list-style-type none
    ul.mt-leyenda li
        display inline
    ul.mt-leyenda:after, l.mt-leyenda li:after
        clear both
        display " "
    li.mt-list-cita
        border-bottom 1px solid #e4e9f0
        border-right 1px solid #e4e9f0
        padding 15px
        margin 0
    .mt-calendar2>tbody>tr>td, .mt-calendar2>tbody>tr>th
        border none
        border-right 1px solid #ddd
    .mt-calendar2>tbody>tr, .mt-calendar2>tbody>tr
        border none
    .mt-cita-detail
        padding 0
        margin 10px
        -webkit-border-radius 15px
        -moz-border-radius 15px
        border-radius 15px
        color #ffffff
    .tooltip
        position relative
        /* display inline-block */
        border-bottom 1px dotted black
    .tooltip .tooltiptext
        visibility hidden
        /* width 120px */
        color #fff
        text-align center
        border-radius 2px
        padding 5px 14px
        position absolute
        z-index 1
        font-size 13px
        bottom 125%
        left 50%
        background-color #384d60
        -webkit-transform translate(-50%, -4px)
        -moz-transform translate(-50%, -4px)
        transform translate(-50%, -4px)
        opacity 0
        transition opacity 1s
    .tooltip .tooltiptext::after
        content ""
        position absolute
        top 100%
        left 50%
        margin-left -5px
        border-width 5px
        border-style solid
        border-color #384d60 transparent transparent transparent
    .tooltip:hover .tooltiptext
        visibility visible
        opacity 1
    @import '../../../assets/styles/responsive.styl'

    .md-input-container.md-input-disabled input.md-input
        color #2c4760!important
</style>
<style scoped>
span.status-diary.success {
    background: #88c94b;
    display: block;
    text-align: center;
    margin: 5px;
}
span.status-diary.error {
    background: #FF5722;
    display: block;
    text-align: center;
    margin: 5px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?7c4c7344